import $ from 'jquery';

const languageSwitcher = () => {

  const init = () => {
    //update language
    if ($('[data-sf-role="ar"], [data-sf-role="en"]').length > 0 && $("[data-lang-link]").length > 0) {
      $("[data-lang-link]").attr("href", $('[data-sf-role="ar"], [data-sf-role="en"]').val()+window.location.hash);
    }
  }

  return {
    init
  }
}

export default languageSwitcher;
